/**
/**
 * ReportUsersSeed entity class
 */

import moment from 'moment'

/**
 * ReportUsersSeedFactory
 * returns ReportUsersSeed entity class
 *
 * @class ReportUsersSeedFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportUsersSeed} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportUsersSeedFactory
 */
/* @ngInject */
export default function ReportUsersSeedFactory ($http, $injector, Entity, ReportSeed, alertLiteSvc) {
  /* === ReportUsersSeed class === */

  /**
   * ReportUsersSeed model
   *
   * @class ReportUsersSeed
   * @classdesc ReportUsersSeed model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportUsersSeed entity fields
   * @return {models.ReportUsersSeed} ReportUsersSeed entity
   */
  function ReportUsersSeed () {
    var obj = ReportSeed.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportUsersSeed.prototype = Object.create(ReportSeed.prototype)
  ReportUsersSeed.prototype.constructor = ReportUsersSeed

  /* === ReportUsersSeed instance methods & fields === */

  Object.assign(ReportUsersSeed.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportUsersSeed#
     * @type {Object}
     */
    _fields: {
      name: String,
      from: moment,
      to: moment,
      periodAmount: 0,
      periodType: 'DAYS', // [ DAYS, WEEKS, MONTHS, YEARS ]
      reportType: 'ACTIVATIONS',
      subscriptionFromDays: Number,
      subscriptionToDays: Number,
      subscriptionFromMonth: Number,
      subscriptionToMonth: Number,
      autoPayEnabled: true,
      includeCustomSubscriptions: false,
      availableAllSubscriptions: true,
      networks: [],
      users: [],
      subscriptions: [],
      paymentSystemTypes: [],
      $bySubscription: 'Length',
      $subscriptionDaily: true,
      $subscriptionMonthly: false
    },

    /**
     * instance fields by types
     *
     * @memberof models.ReportUsersSeed#
     * @type {Object}
     */
    _fieldsByTypes: {},

    /**
     * Get underlying object
     *
     * @memberof models.ReportUsersSeed#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)

      // to utc and ISO_INSTANT_PATTERN
      ret.from = moment(this.from).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      ret.to = moment(this.to).utc().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      ret.users = this.users.map((u) => u.email)
      ret.subscriptions = this.subscriptions.filter((s) => s.id)

      if (!this.$subscriptionDaily) {
        ret.subscriptionFromDays = null
        ret.subscriptionToDays = null
      }

      if (!this.$subscriptionMonthly) {
        ret.subscriptionFromMonth = null
        ret.subscriptionToMonth = null
      }

      return ret
    }
  })

  /* === ReportUsersSeed static methods & fields === */

  /**
   * Search shows by param
   *
   * @param {String} url
   * @param {Object} params
   * @returns {Promise} promise
   */
  ReportUsersSeed.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  // copy all static methods from ReportSeed class
  Object.assign(ReportUsersSeed, ReportSeed)
  ReportUsersSeed._name = 'ReportUsersSeed'
  ReportUsersSeed.init()

  // permissions
  // ReportUsersSeed.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportUsersSeed
}
